import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { supabase } from '../config/supabaseClient';

interface Product {
  id: string;
  name: string;
  description: string;
  price: number;
  images: string[];
  // Add other product fields as needed
}

export const useSellerProductsByUsername = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const { username } = useAuth();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);
        setError(null);

        // First, get the user_id and show_mystore flag from Supabase using the username
        const { data: userData, error: userError } = await supabase
          .from('user')
          .select('user_id, show_mystore')
          .eq('username', username)
          .single();

        if (userError) {
          throw new Error('Failed to fetch user data');
        }

        if (!userData) {
          throw new Error('User not found');
        }

        // Only fetch products if user has show_mystore flag enabled
        if (!userData.show_mystore) {
          setProducts([]);
          return;
        }

        // Now fetch products using the user_id
        const response = await fetch(`https://dev.thesearchbubble.com/api/seller/products/${userData.user_id}`);
        
        if (!response.ok) {
          throw new Error('Failed to fetch products');
        }

        const productsData = await response.json();
        setProducts(productsData.products);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    if (username) {
      fetchProducts();
    }
  }, [username]);

  return { products, loading, error };
}; 